import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Fade } from 'reactstrap';
import qs from 'query-string';
import Loading from '../../components/Loading';
import FormRequest from '../../components/Login/FormRequest';

import {
  setPropsFormPhoneNumerRequest,
  setPropsFormPinRequest,
  _onChangeInputPhone,
  _onChangeInputPin,
  _getPinForAuthorize,
  _registerPhone,
  _getCodeOfAuthorize,
  _goToUrlToSubscription,
  _editPhoneNumber,
  bootstrapData,
  _loadingOn,
  _loadingOff,
  _onChangeSubscriptionPlan
} from './actions';

import {
  selectFormPhoneRequestConfig,
  selectLoading,
  selectPinForAuthorizeLoaded,
  selectPhoneNumber,
  selectPinNumber,
  selectpinForAuthorizeError,
  selectRegisterForm,
  selectSubscriptionPlan
} from './selectors';

// IMPORTS DE ESTILOS E IMAGENES:
import './style.scss';

/**
 * Representa el componente container Home
 *
 * @class LoginPage
 * @extends {React.Component}
 */
export class LoginPage extends React.Component {
  componentWillMount() {
    const { actions } = this.props;
    actions.setPropsFormPhoneNumerRequest();
    actions.onChangeSubscriptionPlan();

    const data = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    actions.bootstrapData(data);

    if (/Android 4\.[0-3]/.test(navigator.appVersion)) {
       window.addEventListener('resize', () => {
          if (document.activeElement.tagName === 'INPUT') {
             window.setTimeout(() => {
                document.activeElement.scrollIntoViewIfNeeded();
             }, 0);
          }
       });
    }
  }

  render() {
    let actionsFailureRedirect;
    const {
      loading,
      formPhoneRequestConfig,
      actions,
      pinForAuthorizeLoaded,
      propsLabelPinRequestOK,
      pinNumber,
      pinForAuthorizeError,
      registerForm,
      failureRedirect,
      subscriptionPlan
    } = this.props;

    const actionsPhoneRequest = {
      _onChange: actions.onChangeInputPhone,
      _onClick: registerForm ? actions.registerPhone : actions.getPinForAuthorize
    };

    const actionsPinRequest = {
      _onChange: actions.onChangeInputPin,
      _onClick: actions.getCodeOfAuthorize
    };

    return (
      <div className="manual_access">
        <div className="form-group">
          {
            (formPhoneRequestConfig && !pinForAuthorizeLoaded)
            && (
              <Fade tab="div" className="col-xs-12 col-sm-12 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                <div>
                  <FormRequest
                    {...formPhoneRequestConfig}
                    {...actionsPhoneRequest}
                    {...failureRedirect}
                    pinForAuthorizeError={{ ...pinForAuthorizeError }}
                    valNumber={propsLabelPinRequestOK.phoneNumber}
                    subscriptionPlan={subscriptionPlan}
                    {...actionsFailureRedirect}
                    pattern='^[0-9]{9}$'
                    activateRecaptcha="true"
                    loadingOn={actions.loadingOn}
                    loadingOff={actions.loadingOff}
                    _onClickExtraAction={actions.getPinForAuthorize}
                    _onChangePlan={actions.onChangeSubscriptionPlan}
                  />
                </div>
              </Fade>
            )
          }

          {
            pinForAuthorizeLoaded
            && (
              <Fade tab="div" className="col-xs-12 col-sm-12 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                <FormRequest
                  {...formPhoneRequestConfig}
                  {...actionsPinRequest}
                  valNumber={pinNumber}
                  subscriptionPlan={subscriptionPlan}
                  extraActiontext="Editar número y generar un nuevo PIN"
                  pinForAuthorizeError={{...pinForAuthorizeError}}
                  _onClickExtraAction={actions.getPinForAuthorize}
                  pattern='\d*'
                  activateRecaptcha="false"
                />
              </Fade>
            )
          }
        </div>
        <Loading isVisible={loading} />
      </div>
    );
  }
}

LoginPage.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  loading: selectLoading(state),
  propsLabelPinRequestOK: {
    phoneNumber: selectPhoneNumber(state)
  },
  pinNumber: selectPinNumber(state),
  pinForAuthorizeLoaded: selectPinForAuthorizeLoaded(state),
  formPhoneRequestConfig: selectFormPhoneRequestConfig(state),
  pinForAuthorizeError: selectpinForAuthorizeError(state),
  registerForm: selectRegisterForm(state),
  failureRedirect: null,
  subscriptionPlan: selectSubscriptionPlan(state)
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    setPropsFormPhoneNumerRequest,
    setPropsFormPinRequest,
    onChangeInputPhone: _onChangeInputPhone,
    onChangeInputPin: _onChangeInputPin,
    getPinForAuthorize: _getPinForAuthorize,
    registerPhone: _registerPhone,
    getCodeOfAuthorize: _getCodeOfAuthorize,
    editPhoneNumber: _editPhoneNumber,
    goToUrlToSubscription: _goToUrlToSubscription,
    bootstrapData,
    loadingOn: _loadingOn,
    loadingOff: _loadingOff,
    onChangeSubscriptionPlan: _onChangeSubscriptionPlan,
  }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
